export default "__VITE_ASSET__CJwdFaE4__"